
class Disbursment {
  disbursement_seq: number;
  disbursement_id: string;
  pic: string;
  client_name: string;
  vessel_name: string;
  segment?: string;
  port_agent: string;
  port: string;
  eta: string;
  etd: string;
  pda_status: string;
  fda_status: string;
  final_status: string;
  due_flag: string;
  due_comment: string;
  due_pda_processing_date: string;
  due_days: number;
  due_color: string;
  pda_id: number;
  fda_id: number;
  pda_state: string;
  fda_state: string;

  constructor(disbursment: any) {
    this.disbursement_seq = disbursment.disbursement_seq || null;
    this.disbursement_id = disbursment.disbursement_id || null;
    this.pic = disbursment.pic || null;
    this.client_name = disbursment.client_name || null;
    this.vessel_name = disbursment.vessel_name || null;
    this.port_agent = disbursment.port_agent || null;
    this.port = disbursment.port || null;
    this.eta = disbursment.eta || null;
    this.etd = disbursment.etd || null;
    this.pda_status = disbursment.pda_status || null;
    this.fda_status = disbursment.fda_status || null;
    this.final_status = disbursment.final_status || null;
    this.due_flag = disbursment.due_flag || null;
    this.due_comment = disbursment.due_comment || null;
    this.due_pda_processing_date = disbursment.due_pda_processing_date || null;
    this.due_days = disbursment.due_days || null;
    this.due_color = disbursment.due_color || null;
    this.pda_id = disbursment.pda_id || null;
    this.fda_id = disbursment.fda_id || null;
    this.pda_state = disbursment.pda_state || null;
    this.fda_state = disbursment.fda_state || null;
  }
}


class FdaDisbursementList {
  disbursement_id: string;
  created_by: string;
  disbursement_seq: number;
  constructor(disbursment: any) {
    this.disbursement_id = disbursment.disbursement_id || null;
    this.created_by = disbursment.created_by || null;
    this.disbursement_seq = disbursment.disbursement_seq || null;
  }
}

class DisbursmentDetails {
  disbursement_seq: number;
  disbursement_id: string;
  client_name: string;
  port_agent_name: string;
  port_agent_office_address: string;
  pic: string;
  ops_pic: string;
  agency_nomination_date: string;
  invoice_number: string;
  pda_id: number;
  pda_received_ops_agent: string;
  pda_processing_date: string;
  pda_status: string;
  portagent_pda_amount: number;
  actual_pda_amount: number;
  pda_remittance: string;
  pda_remark: string;
  fda_id: number;
  fda_state: string;
  fda_received_ops_agent: string;
  fda_processing_date: string;
  portagent_fda_amount: number;
  actual_fda_amount: number;
  fda_status: string;
  fda_remark: string;
  days_outstanding: string;
  vessel_name: string;
  voyage: string;
  port: string;
  country: string;
  purpose: string;
  cargo: string;
  eta: string;
  etd: string;
  sm_estimated_amount: number;
  sm_detailed_entry: string;
  sm_ws_chart_ac: string;
  owners_item_rejected: string;
  towage_agency_agrement: string;
  roe_agent: number;
  roe_actual_oanda: number;
  roe_loss: number;
  loss_prevention_pda: string;
  loss_prevention_fda: string;
  total_loss_prevented: string;
  loss_prevented_reason: string;
  pda_receive_date: string;
  fda_receive_date: string;
  final_status: string;
  due_pda_processing_date: string;
  due_days: number;
  due_comment: string;
  due_flag: string;
  due_color: string;
  advance_percentage: number;
  pda_ptm_curr_to: number;
  fda_ptm_curr_to: number;
  manual_pda_amount: string;
  manual_fda_amount: string;
  pda_expenses: any;
  fda_expenses: any;
  bank_details:any;
  presigned_url:any;
  pdf_name:any;
  vessel_imo:any;

  constructor(details: any) {
    this.disbursement_seq = details.disbursement_seq || null;
    this.disbursement_id = details.disbursement_id || null;
    this.client_name = details.client_name || null;
    this.port_agent_name = details.port_agent_name || null;
    this.port_agent_office_address = details.port_agent_office_address || null;
    this.pic = details.pic || null;
    this.ops_pic = details.ops_pic || null;
    this.agency_nomination_date = details.agency_nomination_date || null;
    this.invoice_number = details.invoice_number || null;
    this.pda_id = details.pda_id || null;
    this.pda_received_ops_agent = details.pda_received_ops_agent || null;
    this.pda_processing_date = details.pda_processing_date || null;
    this.pda_status = details.pda_status || null;
    this.portagent_pda_amount = details.portagent_pda_amount || null;
    this.actual_pda_amount = details.actual_pda_amount || null;
    this.pda_remittance = details.pda_remittance || null;
    this.pda_remark = details.pda_remark || null;
    this.fda_id = details.fda_id || null;
    this.fda_state = details.fda_state || null;
    this.fda_received_ops_agent = details.fda_received_ops_agent || null;
    this.fda_processing_date = details.fda_processing_date || null;
    this.portagent_fda_amount = details.portagent_fda_amount || null;
    this.actual_fda_amount = details.actual_fda_amount || null;
    this.fda_status = details.fda_status || null;
    this.fda_remark = details.fda_remark || null;
    this.days_outstanding = details.days_outstanding || null;
    this.vessel_name = details.vessel_name || null;
    this.voyage = details.voyage || null;
    this.port = details.port || null;
    this.country = details.country || null;
    this.purpose = details.purpose || null;
    this.cargo = details.cargo || null;
    this.eta = details.eta || null;
    this.etd = details.etd || null;
    this.sm_estimated_amount = details.sm_estimated_amount || null;
    this.sm_detailed_entry = details.sm_detailed_entry || null;
    this.sm_ws_chart_ac = details.sm_ws_chart_ac || null;
    this.owners_item_rejected = details.owners_item_rejected || null;
    this.towage_agency_agrement = details.towage_agency_agrement || null;
    this.roe_agent = details.roe_agent || null;
    this.roe_actual_oanda = details.roe_actual_oanda || null;
    this.roe_loss = details.roe_loss || null;
    this.loss_prevention_pda = details.loss_prevention_pda || null;
    this.loss_prevention_fda = details.loss_prevention_fda || null;
    this.total_loss_prevented = details.total_loss_prevented || null;
    this.loss_prevented_reason = details.loss_prevented_reason || null;
    this.pda_receive_date = details.pda_receive_date || null;
    this.fda_receive_date = details.fda_receive_date || null;
    this.final_status = details.final_status || null;
    this.due_pda_processing_date = details.due_pda_processing_date || null;
    this.due_days = details.due_days || null;
    this.due_comment = details.due_comment || null;
    this.due_flag = details.due_flag || null;
    this.due_color = details.due_color || null;
    this.advance_percentage = details.advance_percentage || null;
    this.pda_ptm_curr_to = details.pda_ptm_curr_to || null;
    this.fda_ptm_curr_to = details.fda_ptm_curr_to || null;
    this.manual_pda_amount = details.manual_pda_amount || null;
    this.manual_fda_amount = details.manual_fda_amount || null;
    this.pda_expenses = details.pda_expenses || [];
    this.fda_expenses = details.fda_expenses || [];
     this.bank_details = details.bank_details || [];
      this.presigned_url = details.presigned_url || [];
      this.pdf_name = details.pdf_name || [];
    this.vessel_imo = details.vessel_imo || null; 

  }
}

const columnsToDisplay = [
  { name: 'Timeline', property: 'eye_icon', 'access': [1, 2, 3] },
  { name: 'Disbursement ID', property: 'disbursement_id', 'access': [1, 2, 3] },
  { name: 'Final Status', property: 'final_status', 'access': [1, 2, 3] },
   { name: 'FDA Completed Date(LT)', property: 'fda_completed_date', 'access': [1, 2, 3] },
  { name: 'PIC', property: 'pic', 'access': [1, 2] },
  { name: 'Client', property: 'client_name', 'access': [1, 2] },
  { name: 'PDA Status', property: 'pda_status', 'access': [1, 2, 3] },
  { name: 'FDA Status', property: 'fda_status', 'access': [1, 2, 3] },
  { name: 'Vessel', property: 'vessel_name', 'access': [1, 2, 3] },
  { name: 'Voy no', property: 'voyage', 'access': [1, 2, 3] },
  { name: 'Nomination Date(LT)', property: 'agency_nomination_date', 'access': [1, 2] },
  { name: 'Remittance', property: 'advance_amount_remitted', 'access': [ 1,3] },
  { name: 'Balance', property: 'outstanding_balance', 'access': [1, 3] },
  { name: 'Remarks', property: 'remark', 'access': [1, 3] },
  { name: 'Port', property: 'port', 'access': [1, 2, 3] },
   { name: 'Purpose', property: 'purpose', 'access': [1, 2, 3] },
  { name: 'Port Agent', property: 'port_agent', 'access': [1, 2, 3] },
  { name: 'ETA(LT)', property: 'eta', 'access': [1, 2, 3] },
  { name: 'ETD(LT)', property: 'etd', 'access': [1, 2, 3] },
  { name: 'PDA amount $', property: 'pda_amount', 'access': [1, 2, 3] },
  { name: 'FDA amount $', property: 'fda_amount', 'access': [1, 2, 3] },
  { name: 'PDA Agent Amount', property: 'manual_pda_amount', 'access': [1, 2, 3] },
  { name: 'FDA Agent Amount', property: 'manual_fda_amount', 'access': [1, 2, 3] },
 
  // { name: 'PDA Savings $', property: 'pda_savings', 'access': [3] },
  // { name: 'FDA Savings $', property: 'fda_savings', 'access': [3] },
  { name: 'Total Savings $', property: 'total_savings', 'access': [3] },
  { name: 'Savings Reason', property: 'loss_prevented_reason', 'access': [3] },
  { name: 'Action', property: 'action', 'access': [1, 2] },
  { name: 'Edit', property: 'edit', access: [1, 2, 3] },

];


const ColumnsTodisplayInExportData = [
  { label: 'Disbursement ID', field: 'disbursement_id' },
  { label: 'PIC', field: 'pic' },
  { label: 'Client', field: 'client_name' },
  { label: 'Vessel', field: 'vessel_name' },
  { label: 'Port Agent', field: 'port_agent_name' },
  { label: 'Port', field: 'port' },
  { label: 'ETA', field: 'eta' },
  { label: 'ETD', field: 'etd' },
  { label: 'Country', field: 'country' },
  { label: 'Voyage', field: 'voyage' },
  { label: 'PDA Status', field: 'pda_status' },
  { label: 'PDA Processing Date', field: 'pda_processing_date' },
  { label: 'Purpose', field: 'purpose' },
  { label: 'Cargo', field: 'cargo' },
  { label: 'FDA Received', field: 'fda_receive_date' },
  { label: 'FDA Status', field: 'fda_status' },
  { label: 'FDA Processing Date', field: 'fda_processing_date' },
  { label: 'Agency Nomination Date', field: 'agency_nomination_date' },
  { label: 'Invoice No', field: 'invoice_number' },
  { label: 'PDA Remark', field: 'pda_remark' },
  { label: 'FDA Remark', field: 'fda_remark' },
  { label: 'Estimated Amount', field: 'sm_estimated_amount' },
  { label: 'PDA Amount (USD)', field: 'portagent_pda_amount' },
  { label: 'FDA Amount (USD)', field: 'portagent_fda_amount' },
  { label: 'Agents ROE', field: 'roe_agent' },
  { label: 'Actual ROE from OANDA', field: 'roe_actual_oanda' },
  { label: 'ROE Loss USD', field: 'roe_loss' },
  { label: 'Final Status', field: 'final_status' },
  { label: 'Loss Prevention at PDA ($)', field: 'loss_prevention_pda' },
  { label: 'Loss Prevention at FDA ($)', field: 'loss_prevention_fda' },
  { label: 'Total Loss Prevented ($)', field: 'total_loss_prevented' },
  { label: 'PDA Remittance ($)', field: 'pda_remittance' },
  { label: 'Detailed Entry(Yes/NA)', field: 'sm_detailed_entry' },
  { label: 'Towage / Agency Agreement(Yes/NA)', field: 'towage_agency_agrement' },
  { label: 'Days Outstanding', field: 'days_outstanding' },
  { label: 'WS/Chart A/C (Yes/NA)', field: 'sm_ws_chart_ac' },
  { label: 'Owners Items Rejected(Yes/NA)', field: 'owners_item_rejected' },
  { label: 'Loss Prevented Reason', field: 'loss_prevented_reason' }
]
const formatDate = (date: any): string => {
  if (!date) return '';

  // If already in DD-MM-YYYY format
  if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
    return date;
  }

  const d = new Date(date);

  if (isNaN(d.getTime())) {
    return '';
  }

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};


export {
  Disbursment,
  columnsToDisplay,
  DisbursmentDetails,
  FdaDisbursementList,
  ColumnsTodisplayInExportData,
  formatDate
}
